import * as hosts from '../../constants/hosts';
import request from '../../request';

export interface AreaPositionResponse {
  province: string;
  provinceId: number;
  city: string;
  cityId: number;
  area: string;
  areaId: number;
}

export interface area {
  id: number;
  name: string;
  level?: number;
  pinyin?: string;
}

export interface GetAreaByLevelResponse {
  areaRecords: area[];
}

export interface GetAreaByNameResponse {
  areaDetails: area[];
}

/**
 * 经纬度查询地区
 * @param isArea 是否查area表：true查area表,false查腾讯位置服务
 * @param lat 维度
 * @param lng 经度
 * @returns
 */
export function getAreaByPos(params: {
  isArea: boolean;
  lat: string;
  lng: string;
}) {
  const res = request.get<any, AreaPositionResponse>(
    '/base-interface/area/GetAreaByPos',
    {
      params,
      baseURL: hosts.GENERAL,
    }
  );

  return res;
}

/**
 * 获取所有城市
 * @param level 等级 1-省 2-市 3-区
 * @returns
 */
export function getAreaByLevel(level: number) {
  const res = request.get<any, GetAreaByLevelResponse>(
    '/base-interface/area/GetAreaByLevel',
    {
      params: { level },
      baseURL: hosts.GENERAL,
    }
  );

  return res;
}

/**
 * 模糊搜索地区
 * @param name 搜索名称
 * @param level 地区等级
 * @returns
 */
export function getAreaByName(params: { name: string; level?: 2 }) {
  const res = request.get<any, GetAreaByNameResponse>(
    '/base-interface/area/BatchGetAreaNamesByName',
    {
      params,
      baseURL: hosts.GENERAL,
    }
  );

  return res;
}

////////////////// 用户相关 /////////////////

export interface CityInfo {
  id?: number;
  cityId: number;
  cityName: string;
  visitTime: number;
}
export interface UserHistoryAreasResponse {
  userId: string;
  lastVisitTime: number;
  areaHistory: CityInfo[];
}

/**
 * 获取用户历史访问地址（城市），最多9个地址
 * @returns
 */
export function getUserHistoryAreas() {
  const res = request.get<any, UserHistoryAreasResponse>(
    '/user-interface/user/patient/GetUserAreasHistory',
    {
      baseURL: hosts.GENERAL,
    }
  );

  return res;
}

/**
 * 获取用户最当前设置的城市，没有默认返回北京
 * @returns
 */
export function getUserLastArea() {
  const res = request.get<any, CityInfo>(
    '/user-interface/user/patient/GetUserLastAreas',
    {
      params: {
        role: 2,
      },
      baseURL: hosts.GENERAL,
    }
  );

  return res;
}

/**
 * 设置用户当前城市
 * @param role 用户角色 1-医生 2-患者 3-其他
 * @param cityId （访问或者点击城市）保存所有城市
 * @returns
 */
export function setUserHistoryArea(data: { role: number; cityId: number }) {
  const res = request.post<any, any>(
    '/user-interface/user/patient/SetUserAreasHistory',
    {
      data,
      baseURL: hosts.GENERAL,
    }
  );

  return res;
}
